import { RestApiUrl } from '../config';
import { getDevStackMode } from '../../lib/common/devStackMode';

export type AffiliateLinkLoadingAttemptResponse = {
    affiliateLink: string;
    clickId: string;
    timestamp: number;
};

export async function fetchOnlineOfferAffiliateLinkLoadingAttempt({
    userId,
    offerId,
    redirectUrl,
    triggeringEventPlatform,
    shouldUseDevStack,
}: {
    userId: string;
    offerId: string;
    redirectUrl?: string;
    triggeringEventPlatform?: string;
    shouldUseDevStack?: boolean;
}): Promise<AffiliateLinkLoadingAttemptResponse | undefined> {
    console.log(`API call: getting affiliate link loading attempt for offer ${offerId}...`);
    const isDevStackMode = shouldUseDevStack ?? getDevStackMode();
    const restApiUrl = isDevStackMode ? RestApiUrl.dev : RestApiUrl.prod;
    const headers: Headers = new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
    });
    const queryParams = new URLSearchParams({
        userId: encodeURIComponent(userId),
    });
    if (redirectUrl) queryParams.append('redirectUrl', encodeURIComponent(redirectUrl));
    if (triggeringEventPlatform) queryParams.append('triggeringEventPlatform', triggeringEventPlatform);
    queryParams.append('isMobileSafariExtension', triggeringEventPlatform === 'mobileSafariExtension' ? 'true' : 'false');
    const url = `${restApiUrl}user/online/${encodeURIComponent(
        offerId
    )}/affiliate-link/new-loading-attempt?${queryParams.toString()}`;
    try {
        const response = await fetch(url, { method: 'GET', headers });
        console.log(`Response ${response.status} for API call 'get affiliate link loading attempt'`);
        if (response.status === 200) {
            const data: AffiliateLinkLoadingAttemptResponse = await response.json();
            return data;
        }
    } catch (error) {
        console.error('Error fetching affiliate link loading attempt:', error);
    }
    console.error('Error: could not fetch affiliate link loading attempt');
    return undefined;
}
